import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, MessageSquare, Settings, BarChart3 } from 'lucide-react';

const Navbar = ({ onLogout }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    onLogout();
    navigate('/login');
  };

  return (
    <nav className="bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center gap-8">
            <h1 className="text-2xl font-bold text-green-600">WhatsApp Dashboard</h1>
            <div className="flex gap-6">
              <button
                onClick={() => navigate('/dashboard')}
                className="flex items-center gap-2 text-gray-700 hover:text-green-600"
              >
                <BarChart3 size={20} />
                Dashboard
              </button>
              <button
                onClick={() => navigate('/messages')}
                className="flex items-center gap-2 text-gray-700 hover:text-green-600"
              >
                <MessageSquare size={20} />
                Messages
              </button>
              <button
                onClick={() => navigate('/settings')}
                className="flex items-center gap-2 text-gray-700 hover:text-green-600"
              >
                <Settings size={20} />
                Settings
              </button>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
          >
            <LogOut size={20} />
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
